function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from 'react-router';
import { ExternalUrls, WebRoutes } from '@/utils/constants';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Anchor, Container, Text } from '@mantine/core';
import styles from './Footer.module.scss';
import classNames from 'classnames';
export default function Footer(_param) {
    var className = _param.className, containerProps = _param.containerProps, props = _object_without_properties(_param, [
        "className",
        "containerProps"
    ]);
    return /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({
        className: classNames(styles.footerContainer, className)
    }, props), {
        children: /*#__PURE__*/ _jsxs(Container, _object_spread_props(_object_spread({
            size: "xl",
            className: styles.footer
        }, containerProps), {
            children: [
                /*#__PURE__*/ _jsx(Text, {
                    size: "sm",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, {
                        id: "Gd/x0m",
                        defaultMessage: "Copyright \xa9 {year} NightDev, LLC. All Rights Reserved.",
                        values: {
                            year: new Date().getFullYear()
                        }
                    })
                }),
                /*#__PURE__*/ _jsxs(Text, {
                    size: "sm",
                    children: [
                        /*#__PURE__*/ _jsx(Anchor, {
                            size: "sm",
                            component: Link,
                            to: WebRoutes.TERMS,
                            children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "32rBNK",
                                defaultMessage: "Terms of Service"
                            })
                        }),
                        ' • ',
                        /*#__PURE__*/ _jsx(Anchor, {
                            size: "sm",
                            component: Link,
                            to: WebRoutes.PRIVACY,
                            children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "vx0nkZ",
                                defaultMessage: "Privacy Policy"
                            })
                        }),
                        ' • ',
                        /*#__PURE__*/ _jsx(Anchor, {
                            size: "sm",
                            href: ExternalUrls.API_DOCS,
                            target: "_blank",
                            children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "yKOyCk",
                                defaultMessage: "API Documentation"
                            })
                        })
                    ]
                })
            ]
        }))
    }));
}
